import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Type for a basic checkbox field.
 *
 * @props **ariaLabel** adds an aria-label to the component for better accessibility, recommended if there is no associated label
 *
 * @defaultWrappers form-field-checkbox-horizontal
 *
 * @usageNotes
 * Refer to the form-field-checkbox-horizontal wrapper for more info on relevant props.
 */
@Component({
  selector: 'ish-checkbox-field',
  templateUrl: './checkbox-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, FormlyModule, NgClass, TranslateModule],
})
export class CheckboxFieldComponent extends FieldType<FieldTypeConfig> {}
